export default "__VITE_ASSET__DSSsx08D__"